export const GET_PACKS = "dashboard/GET_PACKS";
export const CREATE_PACK = "dashboard/CREATE_PACK";
export const DELETE_PACK = "dashboard/DELETE_PACK";
export const INCREASE_PACK_TOTAL_PLAN = "dashboard/INCREASE_PACK_TOTAL_PLAN";
export const DECREASE_PACK_TOTAL_PLAN = "dashboard/DECREASE_PACK_TOTAL_PLAN";
